var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"163.5","cy":"4.5","r":"4.5","transform":"translate(-158 1)","stroke":"#FFF","strokeWidth":"1.5","fill":"none"}));
}

Circle.defaultProps = {"viewBox":"0 0 11 11"};

module.exports = Circle;

Circle.default = Circle;
